import { BidAuctionIcon, BuildingIcon, ConsortiumIcon, ConstructionIcon, HandshakeIcon } from 'components/new-icons'
import type { OtherProductItem } from 'modules/other-products'

const companyProduct: OtherProductItem = {
  link: '/emprestimo-para-empresa/',
  title: 'Empréstimo para Empresas',
  description: 'Use seu imóvel para fazer seu negócio crescer.',
  icon: BidAuctionIcon
}

const condominiumProduct: OtherProductItem = {
  link: '/condo/',
  title: 'Crédito para Condomínios',
  description: 'Tenha recursos para valorizar o patrimônio sem comprometer o caixa.',
  icon: BuildingIcon
}

const constructionProduct: OtherProductItem = {
  link: '/financiamento-para-construcao/',
  title: 'Crédito para Construção',
  description: 'Comece ou termine a obra com crédito de até 50% do valor do imóvel pronto.',
  icon: ConstructionIcon
}

const consortiumProduct: OtherProductItem = {
  link: '/blog/consorcio/',
  title: 'Consórcio de Carros, Imóveis e Serviços',
  description: 'Conquiste seu próximo sonho de forma planejada e sem pagar juros.',
  icon: ConsortiumIcon
}

const realEstateFinancingProduct: OtherProductItem = {
  link: '/financiamento-imobiliario/',
  title: 'Financiamento Imobiliário SFI',
  description: 'Financie o imóvel que desejar com flexibilidade e condições personalizadas.',
  icon: HandshakeIcon
}

export const homeRenovationOtherProducts: OtherProductItem[] = [
  companyProduct,
  condominiumProduct,
  constructionProduct,
  realEstateFinancingProduct
]

export const homeRenovationMobileOtherProducts: OtherProductItem[] = [
  condominiumProduct,
  constructionProduct,
  consortiumProduct,
  realEstateFinancingProduct
]
